import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../../../main/store/main.store.ts';

import { CharacterBubbleAnimation } from '../../../constants/character-bubble-animations.ts';

import { setCurrentCharacterBubbleAnimation, resetCharacterBubbleAnimation } from '../app-state.slice.ts';
import { APP_STATE_SLICE_NAME } from '../app-state.slice.types.ts';

export const triggerCharacterBubbleAnimationThunk = createAsyncThunk(
  `${APP_STATE_SLICE_NAME}/triggerCharacterBubbleAnimationThunk`,
  async (animation: CharacterBubbleAnimation, { dispatch, getState }): Promise<void> => {
    dispatch(setCurrentCharacterBubbleAnimation(animation));

    // Reset animation after a short delay to allow animation to trigger
    await new Promise((resolve) => setTimeout(resolve, 10));
    const state = (getState() as RootState).appState;
    if (state.currentCharacterBubbleAnimation === animation) {
      dispatch(resetCharacterBubbleAnimation());
    }
  }
);
